// Wrapper Component for the Skeleton Component
import { ReactElement, ReactNode } from 'react';
import { Skeleton } from '@mantine/core';

// Link to Mantine Skeleton Component: https://mantine.dev/core/skeleton/

interface Props {
    isVisible?: boolean;
    className?: string;
    content?: ReactNode;
    height?: number;
    width?: number;
    radius?: number;
}

export function Loading({
  isVisible = true,
  className,
  content,
  height,
  width,
  radius,
}: Props): ReactElement {
  return (
    <Skeleton
      visible={isVisible}
      className={className}
      height={height}
      width={width}
      radius={radius}
    >
      {content}
    </Skeleton>
  );
}
